
const TextareaWithLabel = ({type, name, placeholder, label, register, validator, error, addClass = null, readOnly = false, rowNumber = 1}) => {
  const borderColor = error ? 'border-red-500' : 'border-gray-400'
  return (    
      <div className='flex flex-col gap-y-1 items-start'>
          <label htmlFor={name} className={['text-gray-700 text-sm', addClass].join(' ')}>{label}</label>
          <textarea rows={rowNumber} 
              name={name}
              {...register(name, validator)}
              className={['form-input w-full rounded px-2 py-1 text-base h-[5em] lg:h-auto', borderColor].join(' ')} 
              readOnly={readOnly && 'readOnly'}>

            </textarea>
          <span className="text-sm text-red-600">{error}</span>
      </div>
  );
};

export default TextareaWithLabel;
